export const MAIN_SERVICE_URL = 'https://api.friendsvpnpro.com/api/v1'
// export const MAIN_SERVICE_URL = 'http://192.168.100.7:7000/api/v1'

export const trackingId = 'UA-208050843-2'
